import gql from 'graphql-tag';
import { AssetImageSubtype } from 'src/modules/assets';

import { FRAGMENT_FULL_HERO } from 'src/modules/layout/components/block/fullHero/queries';
import { FRAGMENT_DYNAMIC_ZONES } from 'src/modules/layout/components/dynamicZone/queries';
// import { FRAGMENT_PRODUCT_CARD } from 'src/modules/products';

const FRAGMENT_PRODUCT_CARD = gql`
  fragment productCardFields on Product {
    id
    name_en
    name_de
    slug
    product_categories {
      id
      slug
    }
    product_subcategories @include(if: $withFilters) {
      id
      name_en
      name_de
    }
    location_types @include(if: $withFilters) {
      id
      name_en
      name_de
    }
    assets(where: {subtype: "${AssetImageSubtype.Cutout}"}, sort: "sorting:asc", limit: 1) {
    # assets(where: {subtype: "${AssetImageSubtype.Preview}"}) {
      subtype
      file {
        url
        alternativeText
        # width
        # height
      }
    }
    product_series {
      slug
      name_en
      name_de
      designer {
        id
        name
      }
    }
  }
`;

export const QUERY_MARKETING_PAGE = gql`
  query MarketingPages(
    $slug: String!
    $withFilters: Boolean! = false
    $outputChannel: String! = "de_DE"
  ) {
    marketingPages(where: { slug: $slug }, limit: 1) {
      id
      hero {
        ...fullHero
      }
      slug
      title_en
      title_de
      dynamic_content {
        ...dynamicZone
      }
      products(where: { channels_in: $outputChannel }, sort: "ranking:asc") {
        ...productCardFields
      }
    }
  }
  ${FRAGMENT_FULL_HERO}
  ${FRAGMENT_DYNAMIC_ZONES}
  ${FRAGMENT_PRODUCT_CARD}
`;
